import React, {useState} from "react";
import classNames from "classnames";
import "@/Scss/Components/tabs.scss";

export const Tabs = ({
                         value,                     // активный индекс (controlled)
                         onChange,                  // обработчик переключения (controlled)
                         children,
                         className = '',
                         headerClassName = '',
                         bodyClassName = '',
                         defaultValue = 0,  // активный по умолчанию (uncontrolled)
                     }) => {
    const [currentIndex, setCurrentIndex] = useState(defaultValue);

    const activeIndex = value !== undefined ? value : currentIndex;

    const handleChange = (index) => {
        if (onChange) {
            onChange(index);
        } else {
            setCurrentIndex(index);
        }
    };

    return (
        <div className={classNames("tabs", className)}>
            <div className={classNames("tabs__header", headerClassName)}>
                {React.Children.map(children, (child, index) => (
                    <div
                        role={`button`}
                        className={`tabs__headerItem${index === activeIndex ? " active" : ""}`}
                        onClick={() => handleChange(index)}
                    >
                        {child.props.label}
                    </div>
                ))}
            </div>
            <div className={classNames("tabs__body", bodyClassName)}>
                {children[activeIndex]}
            </div>
        </div>
    );
};

/**
 * Вкладка
 * Использовать вместе с Tabs
 */
export const Tab = ({children}) => {
    return (
        <>{children}</>
    );
};
